<template>
  <div class="notice_mng">
    <div class="operate-box">
      <el-button type="primary" size="small" @click="download()">导出</el-button>
    </div>

    <ComTable ref="table" :filter="formData" :api="tableApi">
      <ComTableColumn
        prop="create_time"
        label="提交时间"
        width="150"
        header-align="center"
        align="center"
      ></ComTableColumn>
      <ComTableColumn
        prop="buy_num"
        label="购买人数"
        width="80"
        header-align="center"
        align="center"
      ></ComTableColumn>
      <ComTableColumn
        prop="cost"
        label="单价"
        width="100"
        header-align="center"
        align="center"
      ></ComTableColumn>
      <ComTableColumn
        prop="total"
        label="总额"
        width="100"
        header-align="center"
        align="center"
      ></ComTableColumn>
      <ComTableColumn label="方案" header-align="center" align="center" column_type="3">
        <template scope="scope">
          {{ scope.row.type_name || scope.row.title }}
        </template>
      </ComTableColumn>
      <ComTableColumn
        prop="status_name"
        label="购买状态"
        width="100"
        header-align="center"
        align="center"
      ></ComTableColumn>
    </ComTable>
  </div>
</template>

<script>
export default {
  props: {
    //保险历史列表接口
    getApiList: {
      type: Function,
      default: () => {},
    },
    //保险历史列表导出接口
    getApiExport: {
      type: Function,
      default: () => {},
    },
    //角色类型
    roleType: {
      type: Number,
      default: "0",
    },
  },
  data() {
    return {
      tableApi: this.getApiList, //表格接口
      //表单数据
      formData: {
        class_id: sessionStorage.getItem("class_id"),
        status: 2,
      },
    };
  },
  methods: {
    //导出
    download() {
      let formData = JSON.parse(JSON.stringify(this.formData));
      formData.is_export = 1;
      this.getApiExport(formData).then((res) => {
        let roleName = "";
        if (this.roleType == 0) {
          roleName = "学员";
        }
        if (this.roleType == 1) {
          roleName = "班主任";
        }
        if (this.roleType == 2) {
          roleName = "专家";
        }
        saveAs(res, `${roleName}保险购买历史表.xls`);
      });
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.form-box {
  padding: 20px 0 10px 0;
  background: #f7f7f7;
  .el-form-item {
    margin-bottom: 10px;
  }
}
.operate-box {
  padding: 0 0 20px 0;
}
</style>
